// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__29jru","inputDescription":"styles_inputDescription__7VUVn"};